/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GrantInfo
 */
export interface GrantInfo {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof GrantInfo
     */
    orgId?: string;
    /**
     * User's role in the org
     * @type {string}
     * @memberof GrantInfo
     */
    grant?: string;
    /**
     * Short version of official name of the role
     * @type {string}
     * @memberof GrantInfo
     */
    shortTitle?: string;
}

/**
 * Check if a given object implements the GrantInfo interface.
 */
export function instanceOfGrantInfo(value: object): boolean {
    return true;
}

export function GrantInfoFromJSON(json: any): GrantInfo {
    return GrantInfoFromJSONTyped(json, false);
}

export function GrantInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'grant': json['grant'] == null ? undefined : json['grant'],
        'shortTitle': json['shortTitle'] == null ? undefined : json['shortTitle'],
    };
}

export function GrantInfoToJSON(value?: GrantInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orgId': value['orgId'],
        'grant': value['grant'],
        'shortTitle': value['shortTitle'],
    };
}

